"use client"

import React, { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import HeadingBanner, { HeadingBanner5, HeadingBanner6, HeadingBanner7 } from "../Components/HeadingBanner";
import axios from "axios";
import { Singlepage } from "../api/Pageapi";
import { Shimmer } from "react-shimmer";
import { Logindetail } from "../context/Logindetail";

export const Footerslug = ({image }) => {

    const [PageDetail, setPageDetail] = useState([])
    const [Isloading, setIsloading] = useState(true)

    const slug = useParams()

    const getslugDetail = () => {
        Singlepage(slug?.slug)
            .then((res) => {
                setPageDetail(res?.data)
                setIsloading(false)
            })
            .catch((err) => {
                setIsloading(true)
            })
    }

    useEffect(() => {
        getslugDetail()
    }, [slug])


    return (
        <>


         {
          PageDetail?.name == "Terms and Conditions" && (
             <HeadingBanner5 image = {image?.terms_image} />
          )
         }

         {
          PageDetail?.name == "Refund & Cancellation Policy" && (
             <HeadingBanner6 image = {image?.refund_image} />
          )
         }

          {
          PageDetail?.name == "Privacy Policy" && (
             <HeadingBanner7 image = {image?.privacy_image} />
          )
         }

            <section className="my-5 py-2">
                <div className="container py-2 termpagesize">
                    <h2>{PageDetail?.name ? PageDetail?.name : 'Loading....'}</h2>
                    {
                        Isloading ? Array.from({ length: 3 }).map((_, i) => (
                            <div className="my-3 " key={i}>
                                <div><Shimmer width={400} height={40} className="rounded" /></div>
                                <div><Shimmer height={150} className="rounded w-100 mt-2" /></div>
                            </div>
                        ))
                            : PageDetail ? ( <h4 className='1bh-base fw-normal ' dangerouslySetInnerHTML={{ __html: PageDetail?.description }}></h4>) : ''
                    }
                </div>

            </section>

        </>
    )
}
